// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"5ec2120f","787":"763476dc"}[chunkId] + ".chunk.js";
};